import _toConsumableArray from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.array.map.js";
import { arrayToggle, keysToCamel } from "../../../common/helpers";
import { clone } from 'lodash';
export function UPDATE_MAINLIST_SELECTED(state, payload) {
  var selected = payload.data;
  var side = payload.side;
  state.mainlists[side] = Object.assign({}, state.mainlists[side], {
    selected: selected
  });
}
export function SET_MAINLIST(state, payload) {
  state.mainlists[payload.side] = Object.assign({}, state.mainlists[payload.side], {
    data: payload.data.data,
    meta: keysToCamel(payload.data.meta)
  });
}
export function SET_MAINLIST_SELECTED(state, payload) {
  setMainlistSelected(payload.side, state, payload.item);
}
var setMainlistSelected = function setMainlistSelected(key, state, item) {
  var selected = [];
  if (state.mainlists[key].selected.length > 0) {
    selected = state.mainlists[key].selected;
    if (selected.some(function (d) {
      return d.id === item.id;
    })) {
      selected.forEach(function (d, index) {
        if (d.id === item.id) {
          selected.splice(index, 1);
        }
      });
    } else {
      selected.push(item);
    }
  } else {
    selected.push(item);
  }
  state.mainlists[key] = Object.assign({}, state.mainlists[key], {
    selected: selected
  });
};
export function MAINLIST_SELECT_ALL(state, payload) {
  var selected = payload.item ? JSON.parse(JSON.stringify(state.mainlists[payload.side].data)) : [];
  state.mainlists[payload.side] = Object.assign({}, state.mainlists[payload.side], {
    selected: selected
  });
}
export function PUSH_MAINLIST(state, payload) {
  state.mainlists[payload.side] = Object.assign({}, state.mainlists[payload.side], {
    data: [].concat(_toConsumableArray(state.mainlists[payload.side].data), _toConsumableArray(payload.data.data)),
    meta: keysToCamel(payload.data.meta)
  });
}
export function REMOVE_MAINLIST_SELECTED(state, payload) {
  payload.sides.forEach(function (side) {
    var selected = state.mainlists[side].selected.filter(function (item) {
      return !payload.ids.includes(item.id);
    });
    state.mainlists[side] = Object.assign({}, state.mainlists[side], {
      selected: selected
    });
  });
}
export function UPDATE_SELECTED_QUERIES(state, payload) {
  if (payload.sides) {
    payload.sides.forEach(function (side) {
      // Update on Topic Assignment
      if (payload.topic && payload.ids && payload.ids.length) {
        payload.ids.forEach(function (id) {
          var query = state.mainlists[side].selected.find(function (q) {
            return q.id === id;
          });
          query.mesh = payload.topic;
        });
      }
      // Update on Attach/Detach Query
      if (payload.query) {
        var selected = state.mainlists[side].selected.find(function (q) {
          return q.id === payload.ids[0];
        });
        selected && Object.assign(selected, payload.query);
      }
    });
  }
}
export function UPDATE_SELECTED_TOPICS(state, payload) {
  if (payload.sides) {
    payload.sides.forEach(function (side) {
      payload.topics.forEach(function (t) {
        var selected = state.mainlists[side].selected;
        var index = selected.findIndex(function (i) {
          return i.id === t.id;
        });
        if (index) {
          Object.assign(selected[index], t);
        }
      });
    });
  }
}
export function ON_EXPAND_TOGGLE(state, payload) {
  var expanded = clone(state.mainlists[payload.side].expanded);
  arrayToggle(expanded, payload.id);
  state.mainlists[payload.side].expanded = expanded;
}
export function ON_EXPAND_CHILD_TOGGLE(state, payload) {
  var expanded = clone(state.mainlists[payload.side].expandedChildren);
  arrayToggle(expanded, payload.id);
  state.mainlists[payload.side].expandedChildren = expanded;
}
export function EXPAND_ALL(state, side) {
  state.mainlists[side].expanded = [];
  state.mainlists[side].expanded = state.mainlists[side].data.map(function (o) {
    return o.id;
  });
}
export function EXPAND_ALL_CHILDREN(state, payload) {
  state.mainlists[payload.side].expandedChildren = [];
  state.mainlists[payload.side].expandedChildren = payload.ids;
}
export function COLLAPSE_ALL(state, side) {
  state.mainlists[side].expandedChildren = [];
  state.mainlists[side].expanded = [];
}
export function TRIGGER_SEARCH(state, side) {
  state.mainlists[side].searchTriggered = new Date().toLocaleString();
}